<template>
  <v-container>
    <h1 class="mb-4">Call Analysis</h1>
    <div class="d-flex flex-column flex-md-row">
      <!-- ------------ Sidebar (Desktop) ------------ -->
      <div class="sidebar the-thin-grey-border flex-column d-none d-md-flex flex-1">
        <v-tabs v-model="tab" vertical>
          <!-- <v-tab>Dashboard</v-tab> -->
          <v-tab>Trends</v-tab>
          <v-tab>Interactive</v-tab>
          <v-tab>Explorer</v-tab>
          <!-- <v-tab disabled>Training</v-tab> -->
          <v-tab>Concept</v-tab>
          <v-tab>Background</v-tab>
        </v-tabs>
      </div>
      <!-- ------------ Top Bar (Mobile) ------------ -->
      <div class="d-flex the-thin-grey-border flex-row d-md-none">
        <v-tabs v-model="tab">
          <!-- <v-tab>Dashboard</v-tab> -->
          <v-tab>Trends</v-tab>
          <v-tab>Interactive</v-tab>
          <v-tab>Explorer</v-tab>
          <v-tab>Concept</v-tab>
          <v-tab>Background</v-tab>
        </v-tabs>
      </div>
      <!-- ------------ Main Content ------------ -->
      <div class="d-flex the-thin-grey-border flex-column flex-3 ml-md-4 mt-md-0 mt-4">
        <v-tabs-items v-model="tab">
          <!-- ------ Dashboard ------ -->
          <!-- <v-tab-item>
            <h1 class="my-4 black--text">Dashboard</h1>
            <v-divider class="mx-12"></v-divider>
            <CallAnalysisDashboard />
          </v-tab-item> -->
          <!-- ------ Trends ------ -->
          <v-tab-item>
            <h1 class="my-6 black--text">Trends</h1>
            <v-divider class="mx-12"></v-divider>
            <CallAnalysisTrends @switch-to-interactive="switchToInteractiveWithData" />
          </v-tab-item>
          <!-- ------ Interactive ------ -->
          <v-tab-item>
            <h1 class="my-6 black--text">Interactive</h1>
            <v-divider class="mx-12"></v-divider>
            <CallAnalysisInteractive 
              ref="interactiveComponent"
              :shared-call-data="sharedCallAnalysisData"
              @clear-shared-data="clearSharedCallData"
            />
          </v-tab-item>
          <!-- ------ Explorer ------ -->
          <v-tab-item>
            <h1 class="my-6 black--text">Explorer</h1>
            <v-divider class="mx-12"></v-divider>
            <CallAnalysisExplorer />
          </v-tab-item>
          <!-- ------ Training ------ -->
          <!-- <v-tab-item> -->
            <!-- <h1 class="my-6 black--text">Training</h1>
            <v-divider class="mx-12"></v-divider>
            <CallAnalysisTraining /> -->
          <!-- </v-tab-item> -->
          <!-- ------ Concept ------ -->
          <v-tab-item>
            <h1 class="my-6 black--text">Original Concept</h1>
            <v-divider class="mx-12"></v-divider>
            <CallAnalysisConcept />
          </v-tab-item>
          <!-- ------ Background ------ -->
          <v-tab-item>
            <h1 class="my-6 black--text">Background</h1>
            <v-divider class="mx-12"></v-divider>
            <CallAnalysisBackground />
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>
  </v-container>
</template>

<script>
import CallAnalysisDashboard from '@/components/CustomerService/CallAnalysisDashboard.vue';
import CallAnalysisTrends from '@/components/CustomerService/CallAnalysisTrends.vue';
import CallAnalysisInteractive from '@/components/CustomerService/CallAnalysisInteractive.vue';
import CallAnalysisExplorer from '@/components/CustomerService/CallAnalysisExplorer.vue';
import CallAnalysisConcept from '@/components/CustomerService/CallAnalysisConcept.vue';
import CallAnalysisBackground from '@/components/CustomerService/CallAnalysisBackground.vue';

export default ({
  name: 'CustomerServiceCallAnalysis',
  props: ['user'],
  components: {
    CallAnalysisDashboard,
    CallAnalysisTrends,
    CallAnalysisInteractive,
    CallAnalysisExplorer,
    CallAnalysisConcept,
    CallAnalysisBackground,
  },
  data: () => ({
    tab: 0,
    // Shared state for component communication
    sharedCallAnalysisData: {
      selectedCalls: [],
      selectedCallsMetadata: null,
      dateRange: {
        start: null,
        end: null
      }
    }
  }),
  methods: {
    // Method for child components to update shared data
    updateSharedCallData(data) {
      console.log('CallAnalysis: updateSharedCallData called with:', data);
      console.log('CallAnalysis: current sharedCallAnalysisData before update:', this.sharedCallAnalysisData);
      this.sharedCallAnalysisData = {
        ...this.sharedCallAnalysisData,
        ...data
      };
      console.log('CallAnalysis: sharedCallAnalysisData after update:', this.sharedCallAnalysisData);
    },
    
    // Method to clear shared data
    clearSharedCallData() {
      this.sharedCallAnalysisData = {
        selectedCalls: [],
        selectedCallsMetadata: null,
        dateRange: {
          start: null,
          end: null
        }
      };
    },
    
    // Method to switch to Interactive tab with data
    switchToInteractiveWithData(data) {
      console.log('CallAnalysis: switchToInteractiveWithData called with data:', data);
      this.updateSharedCallData(data);
      console.log('CallAnalysis: switching to Interactive tab (index 1)');
      this.tab = 1; // Switch to Interactive tab (index 1)
      console.log('CallAnalysis: current tab after switch:', this.tab);
      
      // Use nextTick to ensure the Interactive component is ready
      this.$nextTick(() => {
        console.log('CallAnalysis: nextTick - accessing Interactive component via ref');
        if (this.$refs.interactiveComponent) {
          console.log('CallAnalysis: Found Interactive component via ref, triggering processSharedData');
          this.$refs.interactiveComponent.processSharedData();
        } else {
          console.log('CallAnalysis: Interactive component ref not found');
        }
      });
    }
  },
  created() {
    // Handle tab switching from query parameters
    console.log('CallAnalysis created with route query:', this.$route.query);
    if (this.$route.query.tab) {
      const tabMap = {
        'trends': 0,
        'interactive': 1,
        'explorer': 2,
        'concept': 3,
        'background': 4
      };
      const newTab = tabMap[this.$route.query.tab] || 0;
      console.log(`Switching to tab: ${this.$route.query.tab} (index: ${newTab})`);
      this.tab = newTab;
    }
  },
  watch: {
    '$route': {
      handler: function(newRoute) {
        console.log('CallAnalysis route changed:', newRoute.query);
        if (newRoute.query.tab) {
          const tabMap = {
            'trends': 0,
            'interactive': 1,
            'explorer': 2,
            'concept': 3,
            'background': 4
          };
          const newTab = tabMap[newRoute.query.tab] || 0;
          console.log(`Switching to tab: ${newRoute.query.tab} (index: ${newTab})`);
          this.tab = newTab;
        }
      },
      immediate: true
    }
  },
})
</script>

<style lang="scss" scoped>
.message {
  .system-message {
    max-width: 80%;
    background: #f0f0f0;
    color: black;
    border-radius: 10px;
    text-align: left !important;
  }

  .user-message {
    max-width: 80%;
    background: #4caf50;
    color: white;
    border-radius: 10px;
  }
}

.citations {
  font-size: 0.875rem;
  color: #757575;
}

.sidebar {
  min-width: 250px;
  max-width: 250px;
  width: 250px;
}
.the-thin-grey-border {
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  overflow: hidden;
}
.chart {
  height: 400px;
  width: 100%;
}
</style>